import React, { useEffect } from 'react';
import bushome from '../../assets/images/bushome.png';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormControl,
	Hidden,
} from '@material-ui/core';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import p1 from '../../assets/images/p-1.jpg';
import p2 from '../../assets/images/p-2.jpg';
import p3 from '../../assets/images/p-3.jpg';
import p4 from '../../assets/images/p-4.jpg';
import p5 from '../../assets/images/p-5.jpg';
import p6 from '../../assets/images/p-6.jpg';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/busnew.svg';
import blog1 from '../../assets/images/blog-1.svg';
import blog2 from '../../assets/images/blog-2.svg';
import blog3 from '../../assets/images/blog-3.svg';
import '../home.css';
import SearchForm from '../../components/reusableComponents/SearchForm';
import SearchFlight from '../../form/SearchFlight';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import { toggleLoginModal } from '../../reducers/UiReducer';
import Login from '../../components/reusableComponents/Login';
import { useDispatch } from 'react-redux';
import TitleText from '../../components/reusableComponents/TitleText';
import { useHistory } from 'react-router-dom';
import BusServiceForm from '../../form/BusServiceForm';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import { fetchBusCityDispatch } from '../../reducers/BusReducer';
const useStyles = makeStyles((theme) => ({
	back: {
		backgroundImage: `url(https://nitish.musafirbazar.com/static/media/bus.jpg)`,
		height: 1189,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '1px -323px',
		position: 'relative',
		[theme.breakpoints.up('lg')]: {
			height: 494,
		},
		[theme.breakpoints.down('xs')]: {
			height: 1144,
		},
	},
}));
function BusServicePage() {
	const handleTheme = () => {
		let themeBtn = document.querySelector('#theme-btn');
		themeBtn.classList.toggle('fa-sun');

		if (themeBtn.classList.contains('fa-sun')) {
			document.body.classList.add('active');
		} else {
			document.body.classList.remove('active');
		}
	};
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	let body = {};
	useEffect(() => {
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
		dispatch(fetchBusCityDispatch(body));
	}, []);
	window.onscroll = () => {
		let loginForm = document.querySelector('.login-form');
		let navbar = document.querySelector('.navbar');
		navbar.classList.remove('active');
		loginForm.classList.remove('active');
	};
	return (
		<>
			{/* <!-- header section starts  --> */}
			<HeaderSection id={3} />
			{/* header section ends */}
			<section
				className='form-container'
				className={classes.back}
				data-aos='zoom-in'>
				{/* <SearchForm /> */}

				<BusServiceForm />
			</section>
			<section className='home' id='home'>
				<div className='image'>
					<img src={bushome} alt='q' />
				</div>

				<div className='content'>
					<h3>Adventure Is Worthwhile</h3>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis
						explicabo eius inventore reprehenderit alias eos facilis, ipsa est
						asperiores repellendus!
					</p>
					<a href='#' className='btn'>
						Explore Now
					</a>
				</div>
			</section>
			<section className='services' id='services'>
				<h1 className='heading'>
					{' '}
					Our <span>Commitment</span>{' '}
				</h1>

				<div className='box-container'>
					<div className='box' data-aos='zoom-in'>
						<span>01</span>
						<i class='fa fa-plus' aria-hidden='true'></i>
						<h3>Safety</h3>
						<p>
							Assured safety with features including well-sanitized buses, panic
							button, GPS tracking, CCTV cameras, ABS & Vehicle Rollover
							protection.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>02</span>
						<i className='fas fa-bus'></i>
						<h3>Comfort</h3>
						<p>
							Unparalleled comfort including noiseless cabins, ultra-wide
							Maharaja seats with up to 140 degrees recline, extra legroom, and
							calf support.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>03</span>
						<i className='fas fa-laptop	'></i>
						<h3>Convenience</h3>
						<p>
							Hassle-free and seamless digital booking, boarding, luggage
							tagging along with clean waiting lounges, and pre-defined hygienic
							pit stops.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>04</span>
						<i className='fas fa-globe'></i>
						<h3>Consistency</h3>
						<p>
							Our promise is to deliver the same service every time and all the
							time, we are mad about your experience with us.
						</p>
					</div>
				</div>
			</section>
			<section className='services' id='services'>
				<h1 className='heading'>
					{' '}
					We <span>Promise</span> To <span>Deliver</span>
				</h1>

				<div className='box-container'>
					<div className='box' data-aos='zoom-in'>
						<span>01</span>
						<i class='fa fa-plus' aria-hidden='true'></i>
						<h3>Safety+</h3>
						<p>
							With Safety+ we have brought in a set of measures like Sanitized
							buses, mandatory masks etc. to ensure you travel safely
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>02</span>
						<i className='fas fa-headset'></i>
						<h3>Superior Customer Service</h3>
						<p>
							We put our experience and relationships to good use and are
							available to solve your travel issues.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>03</span>
						<i className='fas fa-rupee-sign	'></i>
						<h3>Lowest Prices</h3>
						<p>
							We always give you the lowest price with the best partner offers.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>04</span>
						<i className='fas fa-solid fa-gift'></i>
						<h3>Unmatched Benifits </h3>
						<p>
							We take care of your travel beyond ticketing by providing you with
							innovative and unique benefits.
						</p>
					</div>
				</div>
			</section>
			<section className='footer'>
				<div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>Musafir Bazar</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Info
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Privacy Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Terms & Condition
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Careers
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i>
							About Us
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Products</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Flight Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Bus Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Hotel Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Holiday Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Car Booking
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Contact Info</h3>
						<a href='#'>
							<i className='fas fa-phone'></i> +91 887-777-3388
						</a>
						<a href='#'>
							<i className='fas fa-envelope'></i>sales@musafirbazar.com
						</a>
						<a href='#'>
							<i className='fas fa-map-marker-alt'></i>1st Floor,New Tech Grand,
							Bank More, Dhanbad-826001
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Follow us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							<i className='fab fa-facebook-f'></i> facebook
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							<i className='fab fa-twitter'></i> twitter
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							<i className='fab fa-instagram'></i> instagram
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							<i className='fab fa-linkedin'></i> linkedin
						</a>
						<a href='#'>
							<i className='fab fa-pinterest'></i> pinterest
						</a>
					</div>
				</div>

				<div className='credit' style={{ fontSize: 14 }}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation Pvt.
					Ltd.
				</div>
			</section>
		</>
	);
}

export default BusServicePage;
